import React, { ReactNode, ChangeEvent, RefObject, useEffect } from "react";
import { AppFormErrorMessages } from "src/commun/composants/formulaire/AppFormErrorMessage/AppFormErrorMessage";
import styles from "./AppTextarea.scss";

export type AppTextareaProps = {
  name: string;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  value: string;
  maxlength: number;
  error?: string;
  touched?: boolean;
  children?: ReactNode;
  fieldRef?: RefObject<HTMLTextAreaElement>;
  reloadValue?: boolean;
  disabled?: boolean;
  isRequired?: boolean;
} & React.ComponentProps<"textarea">;

const AppTextarea = ({
  name,
  onChange,
  value,
  error,
  touched,
  maxlength,
  disabled,
  children,
  fieldRef,
  reloadValue = false,
  isRequired = false,
  ...reste
}: AppTextareaProps) => {
  const [nbCaracteres, setNbCaracteres] = React.useState<number>(value ? value.length : 0);
  const [valueState, setValueState] = React.useState<string>(value || "");

  useEffect(() => {
    if (reloadValue) {
      setValueState(value);
      setNbCaracteres(value ? value.length : 0);
    }
  }, [reloadValue, value]);

  const onChangeInterne = (event: ChangeEvent<HTMLTextAreaElement>) => {
    let texte = event.currentTarget.value;

    if (texte.length > maxlength) {
      texte = texte.substring(0, maxlength);
    }

    setValueState(texte);
    setNbCaracteres(texte.length);

    event.currentTarget.value = texte;

    if (onChange) {
      onChange(event);
    }
  };

  return (
    <div className={styles.textAreaContainer}>
      <textarea       
        name={name}
        id={name}
        onChange={onChangeInterne}
        value={valueState}
        maxLength={maxlength}
        disabled={disabled}
        required={!disabled && isRequired}
        ref={fieldRef}
        {...reste}
        className={`${styles.textAreaContent} ${disabled ? styles.disabled : ""} ${
          error && touched ? styles.textAreaError : ""
        }`}
      >
        {children}
      </textarea>
      <span
        className={`${styles.spanCompteur} ${disabled ? styles.disabled : ""} ${
          nbCaracteres >= maxlength ? styles.tooLong : ""
        }`}
      >
        {nbCaracteres} / {maxlength}
      </span>
      <AppFormErrorMessages erreurs={error} />
    </div>
  );
};

export default AppTextarea;
